/**
 * Resolves an app-relative Okta redirect URI to an absolute URL for browser redirects.
 */
export function resolveOktaUri(uri: string): string {
  if (uri.startsWith('http://') || uri.startsWith('https://')) {
    return uri;
  }

  if (typeof window === 'undefined') {
    return uri;
  }

  const normalizedPath = uri.startsWith('/') ? uri : `/${uri}`;
  return `${window.location.origin}${normalizedPath}`;
}
